<div class="flex-grow-1 card-content-container">
  <ng-container *ngIf="flip === 'inactive'; else showDescription">

    <div
      class="card-text-container d-flex flex-column justify-content-between"
      [class.hasPeriodMinutes]="periodMinutes > 0"
      [class.lines-1]="linesClass === 'lines-1'"
      [class.lines-2]="linesClass === 'lines-2'"
      [class.lines-3]="linesClass === 'lines-3'"
      [class.lines-4]="linesClass === 'lines-4'"
      [class.lines-5]="linesClass === 'lines-5'"
      *ngIf="cardHtml"
    >
      <span
        #cardTextRef
        class="card-text"
        [class.hasPeriodMinutes]="periodMinutes > 0"
        [innerHtml]="cardHtml | safeHtml"
      ></span>
      <span class="period text-center" *ngIf="periodMinutes > 0">
        {{ periodMinutes }}
      </span>
    </div>

    <div
      class="card-text-container hasPeriodMinutes editable lines-1 d-flex flex-column justify-content-between custom"
      *ngIf="isEditable && isUneditedCustom"
    >
      <span class="card-text hasPeriodMinutes text-center" style="padding-bottom: 0.7rem">Custom</span>
      <span class="period text-center">
        <svg-icon
          src="assets/icons/icon-edit.svg"
          [svgStyle]="{ 'width.em': 0.75, 'height.em': 0.75 }"
          class="icon-parchment"
        ></svg-icon>
        <!-- <svg-icon
        src="assets/icons/icon-edit.svg"
        [svgStyle]="{ 'width.em': 0.75, 'height.em': 0.75 }"
        class="icon-parchment"
        (click)="editClicked.emit(); $event.stopPropagation()"
      ></svg-icon> -->
      </span>
    </div>

  </ng-container>
  <ng-template #showDescription>
    <div class="card-text-container d-flex flex-column justify-content-between">
      <div class="card-text card-text-back align-content-center">
        {{ cardDescription }} 
      </div>
    </div>
  </ng-template>
</div>

<svg-icon
  *ngIf="cardDescription && showFlipIcon"
  src="assets/icons/icon-flip.svg"
  class="card-flip-icon"
  [flipCoachTarget]="flipAnchor"
  (click)="flipClicked.emit(); $event.stopPropagation()"
  [svgStyle]="{ 'width.em': 0.625, 'height.em': 1.125 }"
></svg-icon>
